module.exports = __webpack_public_path__ + "static/ocean_stream-ba1e3eb40478b6be1ac21490d8ba3d47.png";